// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N-sM","right":"styles_right__345I0"};